import Parse from "parse";

type OD3_Tenant = Parse.Object;

export interface PageViewAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  tenant: OD3_Tenant;
  hostname: string;
  pageName: string;
  path: string;
  sessionId?: string;
  userAgent?: string;
  language: string;
  referrer?: string;
  screenWidth?: number;
  screenHeight?: number;
  eventType: string; // "pageview" | "video-play" | etc.
  eventData?: string; // JSON string for extra event data
  duration?: number; // seconds spent on the page
  visitorId?: string; // persistent across sessions (localStorage), only with consent
  deviceClass: "mobile" | "tablet" | "desktop"; // coarse, no fingerprinting
}

export class PageView extends Parse.Object<PageViewAttributes> {
  static className: string = "APP_PageView";

  constructor(data?: Partial<PageViewAttributes>) {
    super("APP_PageView", data as PageViewAttributes);
  }
}

Parse.Object.registerSubclass("APP_PageView", PageView);
